import { jsx as _jsx } from "react/jsx-runtime";
import { withVariants } from '../util';
// Replace with delete2/
const Small = (_jsx("svg", Object.assign({ viewBox: "0 0 16 16" }, { children: _jsx("path", { fill: "currentColor", d: "M8.71 8l5.15-5.15a.5.5 0 10-.71-.71L8 7.29 2.85 2.15a.5.5 0 00-.71.71L7.29 8l-5.14 5.15a.5.5 0 10.71.71L8 8.71l5.15 5.15a.5.5 0 00.71-.71z" }, void 0) }), void 0));
export const variants = {
    small: Small,
    default: Small,
};
export default withVariants(variants);
